export default "__VITE_ASSET___EGZh0QT__"